import React from 'react';
import { Loader2, Save } from 'lucide-react';

/**
 * Barra inferior de guardado de las páginas de mensajes WhatsApp.
 * Unifica el botón primario (accent-solid) y el estado deshabilitado
 * (bg-line/text-content-3, legible en ambos modos).
 */
interface SaveBarProps {
  saving: boolean;
  hasChanges: boolean;
  lastUpdated?: Date | null;
  onSave: () => void;
}

const SaveBar: React.FC<SaveBarProps> = ({ saving, hasChanges, lastUpdated, onSave }) => (
  <div className="px-4 sm:px-6 py-4 border-t border-line bg-surface flex items-center justify-between">
    <div className="text-xs text-content-3">
      {lastUpdated && (
        <span>
          Última actualización:{' '}
          {new Intl.DateTimeFormat('es-MX', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
          }).format(lastUpdated)}
        </span>
      )}
    </div>
    <button
      onClick={onSave}
      disabled={saving || !hasChanges}
      className={`inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-accent ${
        hasChanges
          ? 'bg-accent-solid hover:bg-accent-solid/90 text-white'
          : 'bg-line text-content-3 cursor-not-allowed'
      }`}
    >
      {saving ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Save className="h-4 w-4 mr-2" />}
      {saving ? 'Guardando...' : 'Guardar cambios'}
    </button>
  </div>
);

export default SaveBar;
